import React from "react";
import "../Css/About.css"
export default function Notfound() {
  return (
    <div>
      <div className="mtm-10 flex justify-center items-center flex-column">
        
        <dotlottie-player
          src="https://lottie.host/f4a38467-c01c-4d4e-b57f-d1023287e0fb/RFppqSPdyR.json"
          background="transparent"
          speed="1"
          loop
          autoplay
        ></dotlottie-player>
      </div>
      <script src="https://cdn.tailwindcss.com"></script>
    </div>
  );
}
